import React from "react";
import { NavLink } from "react-router-dom";

const StampDutyValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold text-red-600">
        Stamp Duty Valuation
      </h2>

      <div className="space-y-2">
        <p>The Office of Revenue imposes stamp duty on properties in:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>The transfer of agreements in sale of real estate</li>
          <li>Transfer in superannuation or trust entities</li>
          <li>
            Transfer of ownership when a property is changed or transferred
            (e.g., after a sale, or when title is changed to family or friends)
          </li>
        </ul>
      </div>

      <div className="space-y-2">
        <p>
          APVS has been providing certified stamp duty valuations to the Office
          of State Revenue for many years for:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>Individuals</li>
          <li>Solicitors</li>
          <li>Conveyancers</li>
          <li>Businesses</li>
          <li>Corporate Bodies</li>
        </ul>
      </div>

      <p className="text-gray-700">
        Most reports for stamp duty purposes are from a low cost of{" "}
        <strong>$250 plus GST</strong>.
      </p>

      <p className="text-blue-600 font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default StampDutyValuationTab;
